module.exports = __webpack_public_path__ + "img/process.d5e7d5cc.svg";